// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Old layout classes (kept for reference, now unused) ── */
.checkers-page { display: grid; gap: 12px; }
.checkers-layout { display: grid; grid-template-columns: 240px minmax(280px,1fr) 240px; gap: 12px; align-items: start; }
.checkers-layout--practice { grid-template-columns: 220px minmax(280px,1fr); }
.checkers-layout--duel { grid-template-columns: 240px minmax(280px,1fr); }
.checkers-panel { background: rgba(15,23,42,0.75); border: 1px solid rgba(148,163,184,0.25); border-radius: 14px; padding: 12px; color: #e2e8f0; font-size: 14px; }
.checkers-board-wrap { background: rgba(15,23,42,0.7); border: 1px solid rgba(148,163,184,0.2); border-radius: 16px; padding: 10px; display: grid; place-items: center; margin-inline: auto; }

/* ── ck-board-wrap: vertical-layout board container ── */
.ck-board-wrap {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  min-height: 0;
}

.ck-board-wrap .checkers-board {
  width: min(100vw - 4px, 100vh - 260px, 560px);
  max-width: 100%;
}

@media (min-width: 601px) {
  .ck-board-wrap .checkers-board {
    width: min(100vw - 4px, 100vh - 260px, 520px);
  }
}

.checkers-board {
  display: grid;
  grid-template-columns: repeat(8, minmax(28px, 1fr));
  width: min(72vw, 560px);
  max-width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 12px;
  overflow: hidden;
}

.checkers-square {
  position: relative;
  border: none;
  padding: 0;
  margin: 0;
}

.checkers-square--light {
  background: #f1dec0;
}

.checkers-square--dark {
  background: #8b5a2b;
}

.checkers-square--selected {
  box-shadow: inset 0 0 0 3px rgba(250, 204, 21, 0.8);
}

.checkers-square--target {
  box-shadow: inset 0 0 0 3px rgba(52, 211, 153, 0.8);
}

.checkers-square--last {
  box-shadow: inset 0 0 0 3px rgba(59, 130, 246, 0.8);
}

.checkers-piece {
  width: 74%;
  height: 74%;
  border-radius: 999px;
  margin: 13%;
  border: 2px solid rgba(15, 23, 42, 0.6);
  display: grid;
  place-items: center;
  font-weight: 700;
  color: #f8fafc;
  font-size: clamp(12px, 1.8vw, 16px);
}

.checkers-piece--red {
  background: radial-gradient(circle at 30% 30%, #fb7185, #be123c);
}

.checkers-piece--black {
  background: radial-gradient(circle at 30% 30%, #475569, #0f172a);
}

.checkers-clock {
  font-size: 18px;
  font-weight: 700;
}

.checkers-active-turn {
  color: #facc15;
}

.checkers-turn-alert {
  margin-bottom: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.2px;
  color: #052e16;
  background: linear-gradient(90deg, #86efac, #bbf7d0);
  border: 1px solid #22c55e;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.12);
}

.checkers-moves {
  max-height: 320px;
  overflow: auto;
  display: grid;
  gap: 8px;
}

@media (max-width: 1080px) {
  .checkers-layout {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .checkers-board-wrap {
    order: 1;
  }

  .checkers-panel--meta {
    order: 2;
  }

  .checkers-board {
    width: min(calc(100vw - 72px), 500px);
    margin-inline: auto;
  }

  .checkers-panel {
    font-size: 13px;
  }
}

@media (max-width: 640px) {
  .checkers-board-wrap {
    padding: 6px;
    overflow-x: hidden;
  }

  .checkers-board {
    width: min(calc(100vw - 64px), 410px);
    margin-inline: auto;
  }

  .checkers-panel {
    padding: 8px;
    font-size: 12px;
  }

  .checkers-moves {
    max-height: 180px;
  }

  .ck-board-wrap .checkers-board {
    width: min(100vw - 4px, 100vh - 240px, 410px);
  }
}

@media (max-width: 400px) {
  .checkers-board {
    width: calc(100vw - 64px);
    margin-inline: auto;
  }

  .ck-board-wrap .checkers-board {
    width: min(100vw - 4px, 100vh - 220px);
  }

  .checkers-piece {
    font-size: 10px;
  }

  .checkers-clock {
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Checkers.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D,iBAAiB,aAAa,EAAE,SAAS,EAAE;AAC3C,mBAAmB,aAAa,EAAE,oDAAoD,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACvH,6BAA6B,8CAA8C,EAAE;AAC7E,yBAAyB,8CAA8C,EAAE;AACzE,kBAAkB,+BAA+B,EAAE,wCAAwC,EAAE,mBAAmB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AAClK,uBAAuB,8BAA8B,EAAE,uCAAuC,EAAE,mBAAmB,EAAE,aAAa,EAAE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;;AAE7L,yDAAyD;AACzD;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,oDAAoD;EACpD,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ── Old layout classes (kept for reference, now unused) ── */\n.checkers-page { display: grid; gap: 12px; }\n.checkers-layout { display: grid; grid-template-columns: 240px minmax(280px,1fr) 240px; gap: 12px; align-items: start; }\n.checkers-layout--practice { grid-template-columns: 220px minmax(280px,1fr); }\n.checkers-layout--duel { grid-template-columns: 240px minmax(280px,1fr); }\n.checkers-panel { background: rgba(15,23,42,0.75); border: 1px solid rgba(148,163,184,0.25); border-radius: 14px; padding: 12px; color: #e2e8f0; font-size: 14px; }\n.checkers-board-wrap { background: rgba(15,23,42,0.7); border: 1px solid rgba(148,163,184,0.2); border-radius: 16px; padding: 10px; display: grid; place-items: center; margin-inline: auto; }\n\n/* ── ck-board-wrap: vertical-layout board container ── */\n.ck-board-wrap {\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  min-height: 0;\n}\n\n.ck-board-wrap .checkers-board {\n  width: min(100vw - 4px, 100vh - 260px, 560px);\n  max-width: 100%;\n}\n\n@media (min-width: 601px) {\n  .ck-board-wrap .checkers-board {\n    width: min(100vw - 4px, 100vh - 260px, 520px);\n  }\n}\n\n.checkers-board {\n  display: grid;\n  grid-template-columns: repeat(8, minmax(28px, 1fr));\n  width: min(72vw, 560px);\n  max-width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.checkers-square {\n  position: relative;\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n.checkers-square--light {\n  background: #f1dec0;\n}\n\n.checkers-square--dark {\n  background: #8b5a2b;\n}\n\n.checkers-square--selected {\n  box-shadow: inset 0 0 0 3px rgba(250, 204, 21, 0.8);\n}\n\n.checkers-square--target {\n  box-shadow: inset 0 0 0 3px rgba(52, 211, 153, 0.8);\n}\n\n.checkers-square--last {\n  box-shadow: inset 0 0 0 3px rgba(59, 130, 246, 0.8);\n}\n\n.checkers-piece {\n  width: 74%;\n  height: 74%;\n  border-radius: 999px;\n  margin: 13%;\n  border: 2px solid rgba(15, 23, 42, 0.6);\n  display: grid;\n  place-items: center;\n  font-weight: 700;\n  color: #f8fafc;\n  font-size: clamp(12px, 1.8vw, 16px);\n}\n\n.checkers-piece--red {\n  background: radial-gradient(circle at 30% 30%, #fb7185, #be123c);\n}\n\n.checkers-piece--black {\n  background: radial-gradient(circle at 30% 30%, #475569, #0f172a);\n}\n\n.checkers-clock {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.checkers-active-turn {\n  color: #facc15;\n}\n\n.checkers-turn-alert {\n  margin-bottom: 8px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 0.9rem;\n  letter-spacing: 0.2px;\n  color: #052e16;\n  background: linear-gradient(90deg, #86efac, #bbf7d0);\n  border: 1px solid #22c55e;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.12);\n}\n\n.checkers-moves {\n  max-height: 320px;\n  overflow: auto;\n  display: grid;\n  gap: 8px;\n}\n\n@media (max-width: 1080px) {\n  .checkers-layout {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .checkers-board-wrap {\n    order: 1;\n  }\n\n  .checkers-panel--meta {\n    order: 2;\n  }\n\n  .checkers-board {\n    width: min(calc(100vw - 72px), 500px);\n    margin-inline: auto;\n  }\n\n  .checkers-panel {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 640px) {\n  .checkers-board-wrap {\n    padding: 6px;\n    overflow-x: hidden;\n  }\n\n  .checkers-board {\n    width: min(calc(100vw - 64px), 410px);\n    margin-inline: auto;\n  }\n\n  .checkers-panel {\n    padding: 8px;\n    font-size: 12px;\n  }\n\n  .checkers-moves {\n    max-height: 180px;\n  }\n\n  .ck-board-wrap .checkers-board {\n    width: min(100vw - 4px, 100vh - 240px, 410px);\n  }\n}\n\n@media (max-width: 400px) {\n  .checkers-board {\n    width: calc(100vw - 64px);\n    margin-inline: auto;\n  }\n\n  .ck-board-wrap .checkers-board {\n    width: min(100vw - 4px, 100vh - 220px);\n  }\n\n  .checkers-piece {\n    font-size: 10px;\n  }\n\n  .checkers-clock {\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
